export const getFilteredOptions = (options, textValue) => {
  return options.filter(({ label }) =>
    label.toLowerCase().includes(textValue?.trim()?.toLowerCase())
  );
};

export const isAvailable = (options, value) =>
  options.find(({ label }) => label.toLowerCase() === value.toLowerCase());
